import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    directoryNav: {
        accessibility: string;
        hide: string;
        show: string;
    };
    directoryContent: {
        accessibility: string;
        hide: string;
        show: string;
    };
    details: {
        accessibility: string;
        hide: string;
        show: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            directoryNav: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.directoryNav.accessibility?c=1bazrwnmy8ccb", defaultMessage: "Toggle the Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.directoryNav.hide?c=lntz05bdbtl4", defaultMessage: "Hide Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.directoryNav.show?c=9rg4whmyumvu", defaultMessage: "Show Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            directoryContent: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.directoryContent.accessibility?c=3p5i6mra7m0f5", defaultMessage: "Toggle the C2C Connections Directory" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.directoryContent.hide?c=2e7knxyftuo6y", defaultMessage: "Hide the C2C Connections" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.directoryContent.show?c=1919ckcngh1xr", defaultMessage: "Show the C2C connections" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            details: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.details.accessibility?c=9c8b0t286lex", defaultMessage: "Toggle the Device Properties" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.details.hide?c=3s86plkv9ouk", defaultMessage: "Hide Device Properties" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "c2cConnections.details.show?c=2p1r3ion6nnnq", defaultMessage: "Show Device Properties" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
